// polyfills
import "core-js/stable";
import "regenerator-runtime/runtime";
import "whatwg-fetch";
// libraries
import Vue from "vue";
import App from "@/Reports.vue";
import router from "@/router/reports";
import store from "@/store";
import "bootstrap";
import "@/configuration";
import "@/mixins";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
